module.exports = __webpack_public_path__ + "static/media/sgd-15.b0c44708.png";